"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const __1 = require("../..");
const SearchContext_1 = __importDefault(require("../../contexts/SearchContext"));
const TextInput_1 = __importDefault(require("../Input/TextInput"));
const useAddToForwardRef_1 = require("../../hocs/useAddToForwardRef");
const SearchBox = (props) => {
    var _a;
    const { inputValue, setInputValue, setInputFocused, searchInputRef } = react_1.useContext(SearchContext_1.default);
    const refs = useAddToForwardRef_1.useAddToForwardRef(props, [searchInputRef]);
    return (react_1.default.createElement(TextInput_1.default, Object.assign({}, props, { value: (_a = props.value) !== null && _a !== void 0 ? _a : inputValue, onChange: (e) => {
            var _a;
            setInputValue(e.target.value);
            return (_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e);
        }, onFocus: (e) => {
            var _a;
            setInputFocused(true);
            return (_a = props === null || props === void 0 ? void 0 : props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
        }, onBlur: (e) => {
            var _a;
            /* Delay to next frame, think of clicking a button, if this runs before onClick runs on the button it wont work.*/
            setTimeout(() => setInputFocused(false), 100);
            return (_a = props === null || props === void 0 ? void 0 : props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
        }, ref: refs })));
};
exports.default = __1.withJourney('j-search-box', SearchBox);
